import { render, staticRenderFns } from "./EducationTraining.vue?vue&type=template&id=16b2148e"
import script from "./EducationTraining.vue?vue&type=script&lang=js"
export * from "./EducationTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports